module.exports = __webpack_public_path__ + "static/sgm-conducting-bg-8eb9929a3a8cdac05c4d369465c003aa.jpg";